module.exports = __webpack_public_path__ + "static/media/banner-illustrator.fc4242c5.png";